export const getCmsLinkToServices = () => {
    return `/services`;
};
export const getCmsLinkToCatalog = () => {
    return `/catalog`;
};
